import React from 'react';

function Client() {
  const reviews = [
    {
      name: 'Mr. Shinde – Kharadi',
      rating: 5,
      review:
        'Very clean installation and super quick service. Balcony looks neat now and pigeons totally stopped.',
    },
    {
      name: 'Mrs. Patil – Hinjewadi',
      rating: 5,
      review:
        'Team arrived on time, worked safely, and explained everything clearly. Highly trustable service.',
    },
    {
      name: 'Gera Society – Viman Nagar',
      rating: 4,
      review:
        'Commercial quality installation for our ducts. Strong net and secure setup.',
    },
    {
      name: 'Mr. Joshi – Wakad',
      rating: 5,
      review:
        'Called in morning and installation completed same day. Clean finishing and fair pricing.',
    },
    {
      name: 'Sai Residency – Baner',
      rating: 5,
      review:
        'Perfect alignment with grills and walls. Birds fully stopped entering balcony.',
    },
    {
      name: 'Mrs. Sawant – Aundh',
      rating: 4,
      review: 'Quick response and neat installation. Looks premium and safe.',
    },
    {
      name: 'PCMC Housing Project',
      rating: 5,
      review:
        'Handled multiple flats efficiently. Good hardware and strong fitting.',
    },
    {
      name: 'Mr. Mehta – Hadapsar',
      rating: 4,
      review:
        'Strong material and proper support after installation. Good service overall.',
    },
  ];

  return (
    <>
      <section id='clients' className='py-2'>
        <div className='container'>
          {/* Section Heading */}
          <div className='row justify-content-center mb-5' data-aos='fade-up'>
            <div className='col-lg-8 text-center'>
              <h2
                className='fw-bold text-dark mb-2'
                style={{ fontSize: '2.2rem' }}
              >
                What Our Clients Say
              </h2>
              <p
                style={{
                  fontSize: '1rem',
                  color: '#444',
                  maxWidth: '700px',
                  margin: '0 auto',
                  lineHeight: '1.5rem',
                }}
              >
                We believe in delivering quality and trust. Here are some real
                experiences from our customers across Pune.
              </p>
            </div>
          </div>

          {/* Reviews Grid */}
          <div className='row g-3 align-item-center px-5 '>
            {reviews.map((client, index) => (
              <div
                key={index}
                className='col-12 col-md-3 col-lg-6'
                data-aos='zoom-in'
                data-aos-delay={index * 60}
              >
                <div className='card h-100 shadow-sm border-0 p-3 rounded-3 review-card'>
                  {/* Name */}
                  <h6
                    className='fw-semibold mb-1'
                    style={{ color: '#1e88e5', fontSize: '0.95rem' }}
                  >
                    {client.name}
                  </h6>

                  {/* Rating */}
                  <div style={{ marginBottom: '6px' }}>
                    {[...Array(5)].map((_, i) => (
                      <i
                        key={i}
                        className={`bi ${
                          i < client.rating ? 'bi-star-fill' : 'bi-star'
                        } text-warning`}
                        style={{ fontSize: '0.85rem', marginRight: '1px' }}
                      ></i>
                    ))}
                  </div>

                  {/* Review Text */}
                  <p
                    style={{
                      color: '#111',
                      fontSize: '0.92rem',
                      lineHeight: '1.45rem',
                      fontStyle: 'italic',
                      marginBottom: '0',
                    }}
                  >
                    “{client.review}”
                  </p>
                </div>
              </div>
            ))}
          </div>

          {/* Divider */}
          <div className='text-center mt-5'>
            <hr className='w-50 mx-auto' />
          </div>
        </div>
      </section>

      <style>{`
        .review-card {
          transition: all .25s ease-in-out;
          background: #fff;
        }
        .review-card:hover {
          transform: translateY(-6px);
          box-shadow: 0 8px 20px rgba(0,0,0,0.15);
        }
        #clients h2 {
          font-weight: 700;
        }
      `}</style>
    </>
  );
}

export default Client;
